import { DigitalAuditLambdaFetch, awaitJSON } from '@src/utils/fetch-utils';
import {
  AdminBrandListItem,
  Brand,
  Channel,
  FieldCatalogEntry,
  Framework,
  HydratedBrandResponse,
  Skill,
  SkillInput
} from '@blisspointmedia/bpm-types/dist/GoogleAdsAudit';

export const listAdminSkills = async (params?: {
  frameworkId?: string;
  sectionId?: string;
  channelId?: string;
  skillType?: string;
  enabled?: boolean;
}): Promise<Skill[]> => {
  const res = await DigitalAuditLambdaFetch('/google-ads-audit/admin/skills', {
    params: params
      ? Object.fromEntries(
          Object.entries(params)
            .filter(([, v]) => v !== undefined)
            .map(([k, v]) => [k, String(v)])
        )
      : undefined
  });
  return awaitJSON<Skill[]>(res);
};

export const createAdminSkill = async (input: SkillInput): Promise<Skill> => {
  const res = await DigitalAuditLambdaFetch('/google-ads-audit/admin/skills', {
    method: 'POST',
    body: input
  });
  return awaitJSON<Skill>(res);
};

export const getAdminSkill = async (id: string): Promise<Skill> => {
  const res = await DigitalAuditLambdaFetch(`/google-ads-audit/admin/skills/${id}`);
  return awaitJSON<Skill>(res);
};

export const updateAdminSkill = async (id: string, input: SkillInput): Promise<Skill> => {
  const res = await DigitalAuditLambdaFetch(`/google-ads-audit/admin/skills/${id}`, {
    method: 'PUT',
    body: input
  });
  return awaitJSON<Skill>(res);
};

export const deleteAdminSkill = async (id: string): Promise<void> => {
  await DigitalAuditLambdaFetch(`/google-ads-audit/admin/skills/${id}`, { method: 'DELETE' });
};

export const setAdminSkillEnabled = async (id: string, enabled: boolean): Promise<void> => {
  await DigitalAuditLambdaFetch(`/google-ads-audit/admin/skills/${id}/enabled`, {
    method: 'POST',
    body: { enabled }
  });
};

export const listAdminBrands = async (): Promise<AdminBrandListItem[]> => {
  const res = await DigitalAuditLambdaFetch('/google-ads-audit/admin/brands');
  return awaitJSON<AdminBrandListItem[]>(res);
};

export const getAdminBrand = async (id: string): Promise<HydratedBrandResponse> => {
  const res = await DigitalAuditLambdaFetch(`/google-ads-audit/admin/brands/${id}`);
  return awaitJSON<HydratedBrandResponse>(res);
};

export const updateAdminBrand = async (id: string, input: Partial<Brand>): Promise<Brand> => {
  const res = await DigitalAuditLambdaFetch(`/google-ads-audit/admin/brands/${id}`, {
    method: 'PUT',
    body: input
  });
  return awaitJSON<Brand>(res);
};

export const deleteAdminBrand = async (id: string): Promise<void> => {
  await DigitalAuditLambdaFetch(`/google-ads-audit/admin/brands/${id}`, { method: 'DELETE' });
};

export const listChannels = async (): Promise<Channel[]> => {
  const res = await DigitalAuditLambdaFetch('/google-ads-audit/admin/channels');
  return awaitJSON<Channel[]>(res);
};

export const listFrameworks = async (): Promise<Framework[]> => {
  const res = await DigitalAuditLambdaFetch('/google-ads-audit/admin/frameworks');
  return awaitJSON<Framework[]>(res);
};

export const getFieldCatalog = async (
  channel: string
): Promise<{ channel: string; count: number; fields: FieldCatalogEntry[] }> => {
  const res = await DigitalAuditLambdaFetch(`/google-ads-audit/admin/catalog/${channel}`);
  return awaitJSON<{ channel: string; count: number; fields: FieldCatalogEntry[] }>(res);
};
